// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3ukok","checkboxCol":"Table_checkboxCol__3XUNB","emailCol":"Table_emailCol__2FEYf","actionCol":"Table_actionCol__2Kyfc"};